module.exports = __webpack_public_path__ + "static/media/loadingdna.fd903e84.gif";